import FormikInput from "components/input/formik-input";
import { registrationEnum } from "enums/glimps.enums";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import { IPurchaserInfo } from "interfaces/RegisterInterface";
import React from "react";
import Button from "components/button/button";

const validationSchema = Yup.object().shape({
  purchaser_name: Yup.string()
    .trim()
    .min(2, "Name must be at least 2 characters")
    .max(120, "Name is too long")
    .required("Required"),
  purchaser_email: Yup.string()
    .email("Invalid email format")
    .required("Required"),
});

const PurchaserInfo: React.FC<IPurchaserInfo> = ({
  setActiveRegStep,
  handlePurchaserSubmit,
  initialValues,
}) => {
  return (
    <>
      <div className="flex flex-col justify-center topic">
        <h2 className="text-display-lg text-white text-center">
          Tell us about you
        </h2>
        <p className="px-10 mt-4 text-base font-normal leading-4 text-white text-center min-w-[327px]">
          We'll send your purchase receipt to this email.
        </p>
      </div>
      <div className="flex justify-center py-8">
        <div className="bg-white rounded-lg shadow-card w-full max-w-[480px] p-8 flex flex-col">
          <Formik
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={(values) =>
              handlePurchaserSubmit({
                purchaser_name: values.purchaser_name.trim(),
                purchaser_email: values.purchaser_email.trim(),
              })
            }
            enableReinitialize
          >
            {() => (
              <Form className="flex flex-col gap-4">
                <FormikInput
                  id="purchaser_name"
                  name="purchaser_name"
                  label="Your Name"
                  type="text"
                  placeholder="Jane Doe"
                  maxLength={120}
                  autoComplete="name"
                />
                <FormikInput
                  id="purchaser_email"
                  name="purchaser_email"
                  label="Your Email"
                  type="email"
                  placeholder="you@example.com"
                  maxLength={100}
                  autoComplete="email"
                />

                <div className="flex justify-between gap-4 pt-2">
                  <Button
                    type="button"
                    onClick={() =>
                      setActiveRegStep(registrationEnum.subscription)
                    }
                    variant="outline"
                    className="flex-1"
                  >
                    Back
                  </Button>
                  <Button type="submit" variant="primary" className="flex-1">
                    Continue
                  </Button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
      </div>
    </>
  );
};

export default PurchaserInfo;
